// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var PageViews = require("../../../reason/PageViews.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var QueryParams = require("../../../reason/QueryParams.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ConversationsPageRelayCommon_conversationContext_graphql = require("../../../__generated__/ConversationsPageRelayCommon_conversationContext_graphql.bs.js");
var ConversationsPageRelayCommonGetClientNames_client_graphql = require("../../../__generated__/ConversationsPageRelayCommonGetClientNames_client_graphql.bs.js");

function toString(x) {
  switch (x) {
    case "BROADCAST_MESSAGE" :
        return "broadcast";
    case "BUYER_NEED" :
        return "buyer need";
    case "FOR_SALE_PROPERTY" :
        return "property";
    case "RENTAL_NEED" :
        return "rental need";
    case "RENTAL_PROPERTY" :
        return "rental property";
    
  }
}

var EntityType = {
  toString: toString
};

var Conversation = {};

function decodeContextType(x) {
  switch (x) {
    case "buyer_need" :
        return "BUYER_NEED";
    case "broadcast_message" :
    case "message" :
        return "BROADCAST_MESSAGE";
    case "property" :
        return "FOR_SALE_PROPERTY";
    case "rental_need" :
        return "RENTAL_NEED";
    case "rental_property" :
        return "RENTAL_PROPERTY";
    default:
      return ;
  }
}

function encodeContextType(x) {
  switch (x) {
    case "BROADCAST_MESSAGE" :
        return "broadcast_message";
    case "BUYER_NEED" :
        return "buyer_need";
    case "FOR_SALE_PROPERTY" :
        return "property";
    case "RENTAL_NEED" :
        return "rental_need";
    case "RENTAL_PROPERTY" :
        return "rental_property";
    
  }
}

function decode(param) {
  return Core__Option.flatMap(param, decodeContextType);
}

function encode(param) {
  return Core__Option.map(param, encodeContextType);
}

var ContextTypeParam = {
  decodeContextType: decodeContextType,
  encodeContextType: encodeContextType,
  decode: decode,
  encode: encode
};

var config = Object.fromEntries([
      [
        "context_id",
        QueryParams.UseQueryParams.ParamConfigs.stringParam
      ],
      [
        "context_type",
        {
          encode: encode,
          decode: decode
        }
      ]
    ]);

var ParamsConfig = {
  ContextTypeParam: ContextTypeParam,
  config: config
};

var UseQueryParams = QueryParams.UseQueryParams.Make({
      config: config
    });

var QueryParams_use = UseQueryParams.use;

var QueryParams$1 = {
  ParamsConfig: ParamsConfig,
  UseQueryParams: UseQueryParams,
  use: QueryParams_use
};

function ConversationsPageRelayCommon$RecordPageView$RecordPage(props) {
  var activeConversationId = props.activeConversationId;
  var secondaryResource = props.secondaryResource;
  var activeConversationIdAsString = Core__Option.getOr(Core__Option.map(activeConversationId, (function (x) {
              if (x.TAG === "Existing") {
                return x._0;
              } else {
                return "new:" + toString(x._0) + ":" + x._1;
              }
            })), "");
  var page = React.useMemo((function () {
          return PageViews.Page.makeConversationsPage(Core__Option.flatMap(activeConversationId, (function (id) {
                            if (id.TAG === "Existing") {
                              return id._0;
                            } else {
                              return "new";
                            }
                          })), secondaryResource, undefined);
        }), [activeConversationIdAsString]);
  return JsxRuntime.jsx(PageViews.RecordPageView.make, {
              page: page
            });
}

var RecordPage = {
  make: ConversationsPageRelayCommon$RecordPageView$RecordPage
};

function ConversationsPageRelayCommon$RecordPageView$ConversationsList(props) {
  return JsxRuntime.jsx(ConversationsPageRelayCommon$RecordPageView$RecordPage, {
              secondaryResource: undefined,
              activeConversationId: undefined
            });
}

var ConversationsList = {
  make: ConversationsPageRelayCommon$RecordPageView$ConversationsList
};

var convertFragment = ConversationsPageRelayCommon_conversationContext_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsPageRelayCommon_conversationContext_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationsPageRelayCommon_conversationContext_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationsPageRelayCommon_conversationContext_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationsPageRelayCommon_conversationContext_graphql.node, convertFragment, fRef);
}

var ConversationContextFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationsPageRelayCommon$RecordPageView$ConversationViewByConversationContext(props) {
  var conversationContext = useOpt(props.conversationContext);
  var tmp;
  if (conversationContext !== undefined) {
    switch (conversationContext.__typename) {
      case "BuyerNeedV5" :
          tmp = [
            "BUYER_NEED",
            conversationContext.id
          ];
          break;
      case "ForSalePropertyV5" :
          tmp = [
            "PROPERTY",
            conversationContext.id
          ];
          break;
      case "MessageBroadcast" :
          tmp = [
            "BROADCAST_MESSAGE",
            conversationContext.id
          ];
          break;
      case "RentalNeedV5" :
          tmp = [
            "RENTAL_NEED",
            conversationContext.id
          ];
          break;
      case "RentalPropertyV5" :
          tmp = [
            "RENTAL_PROPERTY",
            conversationContext.id
          ];
          break;
      case "__unselected" :
          tmp = undefined;
          break;
      
    }
  } else {
    tmp = undefined;
  }
  return JsxRuntime.jsx(ConversationsPageRelayCommon$RecordPageView$RecordPage, {
              secondaryResource: tmp,
              activeConversationId: props.activeConversationId
            });
}

var ConversationViewByConversationContext = {
  ConversationContextFragment: ConversationContextFragment,
  make: ConversationsPageRelayCommon$RecordPageView$ConversationViewByConversationContext
};

var RecordPageView = {
  RecordPage: RecordPage,
  ConversationsList: ConversationsList,
  ConversationViewByConversationContext: ConversationViewByConversationContext
};

var convertFragment$1 = ConversationsPageRelayCommonGetClientNames_client_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsPageRelayCommonGetClientNames_client_graphql.node, convertFragment$1, fRef);
}

function readInline(fRef) {
  return RescriptRelay_Fragment.readInlineData(ConversationsPageRelayCommonGetClientNames_client_graphql.node, convertFragment$1, fRef);
}

var ClientFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  readInline: readInline
};

function getClientNames(client) {
  var client$1 = readInline(client);
  var match = client$1.contacts;
  var names;
  if (match !== undefined) {
    var edges = match.edges;
    names = edges !== undefined ? Core__Array.keepSome(edges).map(function (edge) {
            return edge.node.displayName;
          }) : [];
  } else {
    names = [];
  }
  if (names.length !== 0) {
    return names.join(", ");
  }
  
}

var Client = {
  ClientFragment: ClientFragment,
  getClientNames: getClientNames
};

exports.EntityType = EntityType;
exports.Conversation = Conversation;
exports.QueryParams = QueryParams$1;
exports.RecordPageView = RecordPageView;
exports.Client = Client;
/* config Not a pure module */
